const FETCH_TICKETS: string = 'tickets/fetchTickets';
const FETCH_TICKET_DETAILS: string = 'tickets/fetchTicketDetails';
const FETCH_TICKET_BY_PLATES: string = 'tickets/fetchTicketByPlates';
const FETCH_STATS: string = 'tickets/fetchStats';
const DETAILS: string = 'tickets/details';
const GET_INVOICE_DATA_FROM_KRS: string = 'tickets/getInvoiceDataFromKrs';
const SAVE_TICKET_ANSWER: string = 'tickets/saveTicketAnswer';
const EXTEND_TICKET: string = 'tickets/extendTicket';

export default {
  FETCH_TICKETS,
  FETCH_TICKET_DETAILS,
  FETCH_TICKET_BY_PLATES,
  FETCH_STATS,
  DETAILS,
  GET_INVOICE_DATA_FROM_KRS,
  SAVE_TICKET_ANSWER,
  EXTEND_TICKET,
};
